import Vue from 'vue';

const getAllPartners = (page = 1) =>
  Vue.http.get(`/api/v2/partners?page=${page}`);

export default getAllPartners;
